import React, { useState, useEffect } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { FaSpinner } from 'react-icons/fa';
import Button from '@material-ui/core/Button';
import { Toast } from 'primereact/toast';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/impressao-aviso-cirurgia.css';

export default function ImpressaoAvisoCirurgia({ pedido, closeDialog, listarPedidosCirurgia }) {
  const [carregarSubmit, setCarregarSubmit] = useState(false);
  const [observacoesAvisoCirurgia, setObservacoesAvisoCirurgia] = useState(null);
  const [toast, setToast] = useState(null);

  const showWarn = (msg, severity) => {
    toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 3000,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();

    const data = {
      observacoesAvisoCirurgia,
    };

    setCarregarSubmit(true);

    pedido.dataImpressaoAvisoCirurgico ?
      dominioDemandaCirurgica().then(promise => {
        window.open(`${promise.config.baseURL}/avisoCirurgia/${pedido.id}`);
        setCarregarSubmit(false);
        closeDialog();
        listarPedidosCirurgia();
        document.location.reload(true);
      }) :
      dominioDemandaCirurgica.put(`/api/dadosImpressaoAvisoCirurgia/${pedido.id}`, data).then(
        async () => {
          await dominioDemandaCirurgica().then(promise => {
            window.open(`${promise.config.baseURL}/avisoCirurgia/${pedido.id}`);
          });
          setCarregarSubmit(false);
          closeDialog();
          listarPedidosCirurgia();
          document.location.reload(true);
        },
        () => {
          setCarregarSubmit(false);
          showWarn('Erro ao imprimir!', 'warn');
        }
      );
  };

  return (
    <Container className="container-pedido-internacao">
      <Toast
        ref={el => {
          setToast(el);
        }}
        position="top-right"
      />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {pedido.dataImpressaoAvisoCirurgico ?
            <strong className="confirmacao-de-reimpressao">Este documento já foi impresso. <br />Tem certeza de que deseja reimprimi-lo?</strong> :

            <Grid item xs={12} sm={12}>
              <TextField
                multiline
                rows={5}
                rowsMax={15}
                name="observacoesAvisoCirurgia"
                variant="outlined"
                fullWidth
                id="observacoesAvisoCirurgia"
                label="Observações"
                value={observacoesAvisoCirurgia}
                onChange={e => setObservacoesAvisoCirurgia(e.target.value)}
                inputProps={{
                  maxlength: 500,
                }}
                InputLabelProps={{ shrink: true }}
                className="observacoesAvisoCirurgia"
                required
              />
            </Grid>}

          <Grid item xs={12} sm={12}>
            <div className="div-botoes">
              <Button type="submit" variant="contained" color="primary">
                {carregarSubmit ? (
                  <FaSpinner color="#FFF" className="loading" size={14} />
                ) : (
                  <> Imprimir </>
                )}
              </Button>
              <Button
                type="button"
                variant="contained"
                color="secondary"
                onClick={() => closeDialog()}
              >
                Cancelar
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
